// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-container {
    display: flex;
    flex-direction: row;
    height: 50vh;
    max-width: 100%;
    margin: 0 auto;
    /*border: 1px solid #ccc;
    border-radius: 8px;*/
    overflow: hidden;
}
.chat-sessions {
    width: 30%;
    
    padding: 10px;
    box-sizing: border-box;
    overflow-y: auto; /* Add vertical scroll */
}
.chat-sessions h3 {
    margin-top: 0;
}

.chat-sessions ul {
    list-style-type: none;
    padding: 0;
}

.chat-sessions li {
    margin-bottom: 10px;
    cursor: pointer;
}
.chat-content {
    width: 70%;
    display: flex;
    flex-direction: column;
    
}

.chat-log {
    flex: 1 1;
    padding: 10px;
    overflow-y: auto;
    background-color: white;
}

.chat-message {
    margin-bottom: 10px;
    padding: 10px;
    border-radius: 4px;
    background-color: #fcfcfc;
}
.chat-message-right {
    background-color: #fafafa;
    align-self: flex-end;
    text-align: right;
}

.chat-message-left {
    background-color: #ffffff;
    align-self: flex-start;
    text-align: left;
}
.chat-query {
    margin: 0;
    font-weight: bold;
    text-align: right;
}
.chat-query-right {
    text-align: right;
}

.chat-query-left {
    text-align: left;
}

.chat-response {
    margin: 0;
    color: #555;
}

.chat-input-container {
    padding: 10px;
    
    background-color: #fff;
}

.chat-input {
    width: calc(100% - 80px);
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 10px; /* Make the border beautifully round */
    margin-right: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Add shadow to create floating effect */
    background-color: #fff; /* Ensure background is white */
    transition: box-shadow 0.3s ease; /* Smooth transition for shadow */
}

.chat-input:focus {
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2); /* Enhance shadow on focus */
}
/* New task styling */
.new-task {
    text-align: right;
    border: 1px solid #007bff;
    border-radius: 4px;
    padding: 10px;
    margin-bottom: 5px;
    font-size: 12px;
    font-weight: bold;;
    cursor: pointer;
    transition: background-color 0.3s;
    width: 30%; /* Adjust the width to be smaller */
    margin-left: auto; /* Align to the right side */
}

.new-task:hover {
    background-color: #e0f7ff;
}
.chat-button {
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    background-color: #007bff;
    color: #fff;
    cursor: pointer;
}

.chat-button:hover {
    background-color: #0056b3;
}

.input-wrapper {
    display: flex;
    align-items: center;
    
    border-radius: 4px;
    padding: 10px;
}`, "",{"version":3,"sources":["webpack://./src/llm/LlmChatView.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,cAAc;IACd;wBACoB;IACpB,gBAAgB;AACpB;AACA;IACI,UAAU;;IAEV,aAAa;IACb,sBAAsB;IACtB,gBAAgB,EAAE,wBAAwB;AAC9C;AACA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;;AAE1B;;AAEA;IACI,SAAO;IACP,aAAa;IACb,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,SAAS;IACT,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;;IAEb,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;IACxB,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAE,sCAAsC;IAC3D,kBAAkB;IAClB,wCAAwC,EAAE,yCAAyC;IACnF,sBAAsB,EAAE,+BAA+B;IACvD,gCAAgC,EAAE,iCAAiC;AACvE;;AAEA;IACI,yCAAyC,EAAE,4BAA4B;AAC3E;AACA,qBAAqB;AACrB;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,iCAAiC;IACjC,UAAU,EAAE,mCAAmC;IAC/C,iBAAiB,EAAE,4BAA4B;AACnD;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;;IAEnB,kBAAkB;IAClB,aAAa;AACjB","sourcesContent":[".chat-container {\n    display: flex;\n    flex-direction: row;\n    height: 50vh;\n    max-width: 100%;\n    margin: 0 auto;\n    /*border: 1px solid #ccc;\n    border-radius: 8px;*/\n    overflow: hidden;\n}\n.chat-sessions {\n    width: 30%;\n    \n    padding: 10px;\n    box-sizing: border-box;\n    overflow-y: auto; /* Add vertical scroll */\n}\n.chat-sessions h3 {\n    margin-top: 0;\n}\n\n.chat-sessions ul {\n    list-style-type: none;\n    padding: 0;\n}\n\n.chat-sessions li {\n    margin-bottom: 10px;\n    cursor: pointer;\n}\n.chat-content {\n    width: 70%;\n    display: flex;\n    flex-direction: column;\n    \n}\n\n.chat-log {\n    flex: 1;\n    padding: 10px;\n    overflow-y: auto;\n    background-color: white;\n}\n\n.chat-message {\n    margin-bottom: 10px;\n    padding: 10px;\n    border-radius: 4px;\n    background-color: #fcfcfc;\n}\n.chat-message-right {\n    background-color: #fafafa;\n    align-self: flex-end;\n    text-align: right;\n}\n\n.chat-message-left {\n    background-color: #ffffff;\n    align-self: flex-start;\n    text-align: left;\n}\n.chat-query {\n    margin: 0;\n    font-weight: bold;\n    text-align: right;\n}\n.chat-query-right {\n    text-align: right;\n}\n\n.chat-query-left {\n    text-align: left;\n}\n\n.chat-response {\n    margin: 0;\n    color: #555;\n}\n\n.chat-input-container {\n    padding: 10px;\n    \n    background-color: #fff;\n}\n\n.chat-input {\n    width: calc(100% - 80px);\n    padding: 20px;\n    border: 1px solid #ccc;\n    border-radius: 10px; /* Make the border beautifully round */\n    margin-right: 10px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Add shadow to create floating effect */\n    background-color: #fff; /* Ensure background is white */\n    transition: box-shadow 0.3s ease; /* Smooth transition for shadow */\n}\n\n.chat-input:focus {\n    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2); /* Enhance shadow on focus */\n}\n/* New task styling */\n.new-task {\n    text-align: right;\n    border: 1px solid #007bff;\n    border-radius: 4px;\n    padding: 10px;\n    margin-bottom: 5px;\n    font-size: 12px;\n    font-weight: bold;;\n    cursor: pointer;\n    transition: background-color 0.3s;\n    width: 30%; /* Adjust the width to be smaller */\n    margin-left: auto; /* Align to the right side */\n}\n\n.new-task:hover {\n    background-color: #e0f7ff;\n}\n.chat-button {\n    padding: 10px 20px;\n    border: none;\n    border-radius: 4px;\n    background-color: #007bff;\n    color: #fff;\n    cursor: pointer;\n}\n\n.chat-button:hover {\n    background-color: #0056b3;\n}\n\n.input-wrapper {\n    display: flex;\n    align-items: center;\n    \n    border-radius: 4px;\n    padding: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
